export default function MeasuringTape(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.1619 3.84326C17.8171 3.84352 22.402 8.42811 22.402 14.0833V24.3099H4.48194C3.07324 24.3099 1.92932 23.172 1.92188 21.7633V14.0833C1.92188 8.42785 6.50646 3.84326 12.1619 3.84326Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.8281 24.3101H30.0683V28.1567"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M23.6797 14.0833V20.4766"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M7.04688 14.0834C7.04688 18.0249 11.3136 20.4882 14.7269 18.5175C16.3111 17.6029 17.287 15.9126 17.287 14.0834C17.287 10.1421 13.0203 7.67875 9.60694 9.64936C8.02278 10.564 7.04688 12.2542 7.04688 14.0834Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	)
}
